import { Head } from "@inertiajs/react"
import { Building2, Search, Shirt } from "lucide-react"

import { Card, CardContent } from "@/components/ui/card"
import { typedPost } from "@/lib/typed-router"
import type { SelectRole } from "@/types/router-mutations"

const roles = [
  {
    key: "player" as const,
    title: "Soy Jugador",
    description: "Creá tu perfil y mostrá tu talento",
    icon: Shirt,
  },
  {
    key: "scout" as const,
    title: "Soy Scout / Representante",
    description: "Descubrí jugadores con potencial",
    icon: Search,
  },
  {
    key: "club" as const,
    title: "Soy Club",
    description: "Encontrá el talento que tu equipo necesita",
    icon: Building2,
  },
]

export default function RoleSelection() {
  function handleSelect(role: string) {
    typedPost<SelectRole>("/onboarding/role", { role })
  }

  return (
    <>
      <Head title="Elegí tu rol" />

      <div className="bg-background flex min-h-svh flex-col items-center justify-center p-6">
        <img
          src="/images/krown_logo_header.png"
          alt="KrownFT"
          className="mb-8 h-10"
        />

        <h1 className="mb-2 text-2xl font-semibold text-white">
          ¿Cómo querés usar KrownFT?
        </h1>
        <p className="text-krown-50/70 mb-8">
          Elegí tu rol para personalizar tu experiencia
        </p>

        <div className="grid w-full max-w-3xl gap-4 sm:grid-cols-3">
          {roles.map((role) => (
            <Card
              key={role.key}
              className="border-krown-600 bg-krown-700 hover:border-krown-accent cursor-pointer transition-all hover:shadow-lg"
              onClick={() => handleSelect(role.key)}
            >
              <CardContent className="flex flex-col items-center gap-3 p-6 text-center">
                <role.icon className="text-krown-accent h-10 w-10" />
                <h2 className="text-lg font-semibold text-white">
                  {role.title}
                </h2>
                <p className="text-krown-50/70 text-sm">{role.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </>
  )
}
